/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:27:28
 */
export default {
  lang: "英语",
  landing: {
    // name1: "Open CarlcareApp",
    name1: "Open Carlcare",
    name2: "Make a reservation",
    // name2: "Buat reservasi",
    // name3: "Use CarlcareApp, you can check the ",
    // name4: "order information at any time!",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    // name7: "Flat Price Battery Replacement (“From Rp120K”)",  // 活动标题 主标题
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline:021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to book Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty:Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    // name80: "Carlcare App",
    // name81: "Carlcare Website",
    // name82: "Carlcare Hotline",
    // name83: "Carlcare WhatsApp",
    name80: "App",
    name81: "Website",
    name82: "Hotline",
    name83: "WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
    name86: "Book Carlcare",
    name87: "Home Service",
    name88: " Today!",
  },
  order: {
    name1: "Choose device model",
    name2: "Fault Description:",
    // name3: "Click to select service store",
    name3: "Tap to select service store",
    name4: "Service Store:",
    name5: "Reservation Time:",
    name6: "Please describe your device problem in detail!",
    // name7: "Click to select arrival time",
    name7: "Tap to select arrival time",
    // name8:
    //   "Please fill in your personal information accurately so that we can contact you!",
    name8:"Please enter your correct contact details so that we can reach you",
    name9: "Available reservation time is as follows!",
    // name10: "Please input your contact number",
    // name10: "Please input your phone number",
    name10: "Please enter your phone number",
    name11: "Price",
    name12: "Personal Information：",
    // name13: "Please input your name",
    name13: "Please enter your name",
    name14: "Submit",
    name15: "Cancel",
    name16: "OK",
  },
  shops: {
    name1: "Based on the brand you choose, the following stores can serve you!",
    name2: "Coming soon in more retail stores! Stay with us!",
  },
  price: {
    name1: "Brand",
    name2: "Model",
    name3: "ITEM",
    name4: "Price",
    name5: "Friendly Reminder:",
    name6:
      "These prices are just for reference, and the actual price is subject to your device condition.",
    name7:
      "If there is no special symbol, the price unit is the local currency unit.",
    // name8: "Sorry! No price info available in the current country site.",
    name8: "Sorry! No price info available in the current region.",
    name11:"Labor Cost",
    name12:"Total Price",
    name13: "5. If the labor cost is \"/\", it means that the labor cost needs to be consulted with the store.",
    item_main_board: "Mainboard",
    item_screen_frame: "Screen(Frame)",
    item_screen_screen_frame: "Secondary Screen(Frame)",
    item_touch_screen: "Touch Screen",
    item_camera: "Camera",
    item_fixed_focus_camera: "Fixed Focus Camera",
    item_auto_focus_camera: "Auto Focus Camera",
    item_screen: "Screen",
    item_secondary_screen: "Secondary Screen",
    item_fingerprint_module: "Fingerprint Module",
    item_speaker: "Speaker",
    item_receiver: "Receiver",
    item_small_board: "Small Board",
    item_battery_cover: "Battery Cover",
    item_battery: "Battery",
    item_charger: "Charger",
    item_usb_cable: "USB Cable",
    item_lcd: "LCD",
  },
  shopDetails: {
    // name1: "No data yet",
    name1: "No data",
    name2: "Service Provider:",
    name3: "Service Brand:",
    name4: "Telephone:",
    name5: "Quantity of Order:",
    name6: "Service Rating",
    name7: "Service Environment:",
    name8: "Service Attitude:",
    name9: "Service Efficiency:",
    name10: "Service Quality:",
    name11: "Customer Evaluation ",
    name12:"to",
    name13:"Closed",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Please take a screenshot to save the reservation information as voucher for priority service.",
    name1:
    "Please screenshot the reservation info and save it as a receipt to access the priority service.",
    name2: "Submitted successfully!",
    name3: "1.Clean up data ",
    // name4: "Please back up important privacy data in your phone in advance.",
    name4: "Please back up important private data on your phone in advance.",
    // name5: "2.Unlock the power-on password",
    name5: "2. Disable the power-on password",
    name6: "Before going to servcie store,please:",
    name7: "Service Store:",
    name8: "Reservation Time:",
    name9: "Fault Description:",
    name10: "Device Model:",
    name11: "Order Number:",
    name12: "Order Information",
  },
  title: {
    name1: "Supports the following countries:",
    name2: "Choose Model",
    name3: "Reservation",
    name4: "Service Store Details",
    name5: "Select Service Store",
  },
  error: {
    name1: "No data! Please check your repair info!",
    name2: "Need more help? Please contact us.",
    // name3: "Sorry,there is no Carlcare center in the current country site.",
    name3: "Sorry, there is no Carlcare center in the current region.",
    // name4: "Please choose service center first!",
    name4: "Please choose a service center first!",
    name5: "Failed",
    // name6: "Please chose device model first!",
    name6: "Please choose the device model first!",
    name7: "Fault Information:",
    name8: "Please describe your requirement in detail!",
  },
  sw:{
    name23:"Phone repair",
    name24:"Repair Accessible",
  },
  add1:{
    "name0": "values-en",
    "name1": "Your order has been confirmed. We look forward to your arrival.",
    "name2": "Select city",
    "name3": "Please input a phone number of %1$s digits.",
    "name4": "Weekday Hours",
    "name5": "Monday",
    "name6": "Tuesday",
    "name7": "Wednesday",
    "name8": "Thursday",
    "name9": "Friday",
    "name10": "Saturday",
    "name11": "Sunday",
    "name12": "Enter country and search"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method:",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Reservation Time:",
    "name7": "Tap to select reservation time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "Others",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
    "name21": "Please allow Carlcare to get your location",
    "name22":"fail to get location, try again pls",
    "name31":"Pick-up and Drop",
  },
  "name58": "Free Cleaning/Free Software Upgrade",
  add3:{
    "name0": "English",
    "name1": "The courier will contact you later",
    "name2": "Home page",
    "name3": "Express details",
    "name4": "copy",
    "name5": "express number copied",
    "name6": "receiver info",
    "name7": "name",
    "name8": "phone number",
    "name9": "address",
    "name10": "pls enter your order number/phone number to view express detail",
    "name11": "Display only the last 30 days of orders",
    "name12": "order number",
    "name13": "create time",
    "name14": "delivery return",
    "name15": "shipper info",
    "name16": "submit",
    "name17": "Do you confirm to delivery the device back to the customer？",
    "name18": "back",
    "name19": "Cancel delivery",
    "name20": "Do you confirm to cancel delivery？",
    "name21": "the order can ‘t be canceled when it had been picked",
    "name23": "Review",
    "name24": "Device has benn deliveried",
    "name25": "Device has benn sent",
    "name26": "Repaired",
    "name27": "In maintenance",
    "name28": "Deliveried, the store has received device",
    "name29": "Waiting for pick-up",
    "name30": "Submit pick-up application",
    "name31": "delivery number:",
    "name32": "You cancel the order",
    "name33": "The courier cancel the order",
    "name33_1": "The admin cancel the order",
    "name34": "Delivery details",
    "name35": "pls enter verification code to cancel order",
    "name36": "send code",
    "name37": "resend",
    "name38": "code",
    "name39": "can‘t be edited",
    "name41": "Pls select the reason for cancellation",
    "name42": "Incorrect info",
    "name43": "Enter reason",
    "name44": "pls enter reason",
    "name45": "Sending",
    "name46": "Due to the distance out of reach, please contact us via WhatsApp, our team will serve you",
    "name47":"Pick Up Delivery Carlcare",
    "name48":"WhatsApp business account",
    "name49":"the store cancel the order",
    "name50":"The order has been cancelled",
    "name51":"JNE Express",
    "name52":"Receiver Info",
    "name53":"Arrived",
    "name54":"On delivery",
    "name55":"Picked",
    "name56":"Go to pick-up location",
    "name57":"Order accepted",
    "name58":"Pending",
  },
  reasonlist:{
    name0:"Change the time of pick up",
    name1:"Incorrect address",
    name2:"Worried about the delivery process,phone will be lost and no compentation",
    name3:"Want to come to SC immediately",
    name4:"Privacy reason",
    name5:"Out of pick up delivery range",
    name6:"Courier doesn't come on time",
  },
  coupons: {
    name1:"Open Carlcare APP to claim coupons",
    name2:"Tap To Go",
    name3:"Open Carlcare APP to rate the order",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Select Service",
    name7:"Free Cleaning",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "Incorrect info",
    "cancelReason1": "Can't arrive on time",
    "cancelReason2": "Duplicate order/not my order",
    "cancelReason3": "Failure does not recur",
    "cancelReason4": "Just for test/inquiry/event/…",
    "cancelReason5": "High price",
    "cancelReason6": "Material shortage",
    "cancelReason7": "No differentiated services",
    "cancelReason8": "The store is too far",
    "cancelReason9": "The store is closed",
    "cancelReason10": "Bad service attitude",
    "cancelReason11": "Replacement/repair for other brands",
    "cancelReason12": "Can't find the store",
    "cancelReason13": "Other",
    "cancelOrder": "Cancel Order",
    "reason_dialog_title": "Please tell us the reason of cancellation",
    "Cancel": "Cancel",
    "OK": "OK",
    "name1": "Enter verification code",
    "name2": "Invalid verification code",
    "repair_reservation_detail_canceled": "Order had been canceled",
    "purchase_cancel_dialog_content": "Confirm to cancel  the order？",
    "yes": "Yes",
    "no": "No"
  }
};